import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { MODULE_INITIALIZER, ProcessModule } from '@spartacus/core';
import { timer } from 'rxjs';
import { CompanyPersistenceService } from './company-persistence.service';
import { COMPANY_FEATURE } from './company-state';
import { reducerProvider, reducerToken } from './reducers';

export function companyStatePersistenceFactory(companyPersistenceService: CompanyPersistenceService): () => void {
  return () => {
    timer(0).subscribe(() => companyPersistenceService.sync());
  };
}

@NgModule({
  imports: [ProcessModule.forRoot(), StoreModule.forFeature(COMPANY_FEATURE, reducerToken)],
  providers: [
    reducerProvider,
    {
      provide: MODULE_INITIALIZER,
      useFactory: companyStatePersistenceFactory,
      deps: [CompanyPersistenceService],
      multi: true,
    },
  ],
})
export class CompanyStoreModule {}
